import { render, staticRenderFns } from "./AccountSignupView.vue?vue&type=template&id=5aa23af3&scoped=true&"
import script from "./AccountSignupView.vue?vue&type=script&lang=js&"
export * from "./AccountSignupView.vue?vue&type=script&lang=js&"
import style0 from "./AccountSignupView.vue?vue&type=style&index=0&id=5aa23af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa23af3",
  null
  
)

/* custom blocks */
import block0 from "./AccountSignupView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports